<script setup lang="ts">
export type BadgeVariant = 'accent' | 'danger' | 'info' | 'neutral' | 'success' | 'warning' | 'outlined'
export type BadgeSize = 'default' | 'small'

withDefaults(defineProps<{ variant?: BadgeVariant; size?: BadgeSize }>(), {
  variant: 'neutral',
  size: 'default',
})
</script>

<template>
  <span :class="['badge', `badge--${variant}`, { 'badge--small': size === 'small' }]"><slot /></span>
</template>

<style scoped lang="scss">
.badge {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--inverted);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
}
.badge--small {
  min-height: 20px;
  padding: 2px 8px;
  border-width: 0;
  border-radius: 24px;
  font-size: 11px;
}
.badge--accent {
  background: #ffc5ec;
  box-shadow: 0 0 0 3px var(--inverted);
  color: #3a0422;
}
.badge--success {
  background: #269b58;
}
.badge--info {
  background: #17a2b8;
}
.badge--neutral {
  background: #b8b8b8;
}
.badge--warning {
  background: #f3ba00;
}
.badge--danger {
  background: #ff5733;
}
.badge--outlined {
  border-color: #eee;
  background: var(--inverted);
  color: var(--primary);
  font-weight: 500;
}
</style>
